import React, { useState } from "react";

import RoomGuestControl from "./RoomGuestControl";
import RoomGuestInput from "./RoomGuestInput";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";

const RoomGuestSelect = ({
  fieldError,
  rooms,
  adults,
  children,
  infants,
  setGuestCount,
  suffixIcon,
  viewRateBlock,
  location,
}) => {
  const [visible, setVisible] = useState(false);

  const hideDropdown = () => {
    setVisible(false);
  };

  const blockPropogation = (e) => {
    e.stopPropagation();
  };

  const openDropdown = (e) => {
    setVisible(true);
  };

  return (
    <div className="w-full h-full relative">
      <RoomGuestInput
        error={fieldError}
        rooms={rooms}
        children={children}
        adults={adults}
        infants={infants}
        onClick={openDropdown}
        suffixIcon={suffixIcon}
        viewRateBlock={viewRateBlock}
      />

      <OutsideClickHandler onOutsideClick={hideDropdown}>
        <div
          className={cn(
            "transition-all duration-170 ease-in absolute top-full z-10 w-full",
            {
              "opacity-1 visible": visible,
              "opacity-0 invisible": !visible,
            }
          )}
          onClick={blockPropogation}>
          <RoomGuestControl
            onChange={setGuestCount}
            rooms={rooms}
            adults={adults}
            children={children}
            infants={infants}
            location={location}
          />
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default RoomGuestSelect;
